


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const geriatic: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} = {
    "en": {
        "url": "geriatric-medicine",
        "meta": {
            "title": "Geriatric Medicine in Dubai | Elite Body Home",
            "description": "Comprehensive geriatric care for elderly patients in Dubai. Specialized treatment for age-related conditions, chronic diseases, and improved quality of life for seniors.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/geriatric-medicine/",
            "og": {
                "title": "Geriatric Medicine in Dubai | Elite Body Home",
                "description": "Holistic and compassionate care for older adults in Dubai",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Geriatric-Medicine-Dubai.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Geriatric Medicine"],
        "hero": {
            "title": "Geriatric Medicine in Dubai",
            "subtitle": "Enhancing the Lifestyle of Elderly",
            "description": "Aging is a normal process and with age our health conditions also become more specialized. Elite Body Home offers the best Geriatric medicine in Dubai to enhance the lifestyle of elderly. Our team of highly trained geriatric specialist provides the holistic and compassionate care to meet the medical, emotional, and functional needs of older adults. We accommodate seniors to enjoy healthier, more autonomous lives, focusing on preventive care, early diagnosis, and comprehensive treatment."
        },
        "howItWorks": {
            "title": "What is Geriatric Medicine?",
            "description": "Specialized branch of medicine applied to health and well-being of elderly people Geriatric medicine/geriatrics It deals with the challenges of aging, from chronic diseases to cognitive decline to mobility problems to emotional health."
        },
        "procedureSteps": {
            "heading": "How Geriatric Medicine at Elite Body Home Works?",
            "para": "Selecting specialized geriatric care guarantees that seniors get customized care for their distinct health requirements. The key benefits include:",
            "steps": [
                {
                    "title": "Comprehensive Assessment",
                    "desc": "Review of medical history, medications, and lifestyle factors followed by evaluation of physical, mental and emotional health.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Individualized Care Plan",
                    "desc": "Creation of personalized treatment plan addressing specific health concerns with recommendations for lifestyle changes, therapy and medications.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Ongoing Monitoring",
                    "desc": "Regular follow-up appointments to track progress and adjust treatment as needed, with coordination across specialists for advanced care when required.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "The key benefits of our geriatric medicine services include:",
            "items": [
                {
                    "title": "Better Management of Chronic Diseases",
                    "desc": "Expert care for ongoing health conditions to improve stability and reduce complications.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Improved Mobility and Strength",
                    "desc": "Therapies and treatments to maintain physical function and independence.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "Enhanced Mental Clarity",
                    "desc": "Support for cognitive function and emotional wellbeing.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Greater Independence",
                    "desc": "Maintaining ability to perform daily activities and live autonomously.",
                    "icon": "fa-solid fa-home"
                }
            ]
        },
        "eligibility": {
            "heading": "Our Services for Geriatric Care",
            "subheading": "",
            "para": "Our geriatric care services focus on:",
            "items": [
                {
                    "title": "Renewed Approach to Aging Diseases",
                    "desc": "Innovative treatments for age-related conditions.",
                    "icon": "fa-solid fa-medal"
                },
                {
                    "title": "Chronic Condition Management",
                    "desc": "Expert care for ongoing health issues.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "Personalized Treatment Plans",
                    "desc": "Tailored approaches for each individual's needs.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Preventive Care",
                    "desc": "Early detection and prevention of health issues.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparing for Your Geriatric Medicine Appointment",
            "subheading": "",
            "para": "Proper planning is critical to getting the best results. Here's how to prepare for your visit:",
            "items": [
                {
                    "title": "Past Medical Records",
                    "desc": "Document of previous ailments and care provided.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "List of Concerns",
                    "desc": "Jot down any symptoms, questions or issues that you'd like the doctor to address.",
                    "icon": "fa-solid fa-list"
                },
                {
                    "title": "Medications & Supplements",
                    "desc": "A list of all medications and supplements, including the doses.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Bring Support",
                    "desc": "If possible, bring a family member or caretaker along for extra support during the appointment.",
                    "icon": "fa-solid fa-hands-helping"
                }
            ]
        },
        "results": {
            "heading": "Results You Can Expect from Geriatric Medicine",
            "subheading": "",
            "para": "Our holistic approach ensures seniors can expect:",
            "items": [
                {
                    "title": "Better Health Outcomes",
                    "desc": "Management of chronic and age-related conditions.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Improved Mental Health",
                    "desc": "Better mood, memory, and overall mental health.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "Greater Independence",
                    "desc": "With mobility and strength.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "Improved Quality of Life",
                    "desc": "Overall improvement in physical, mental and social well-being.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare for Geriatric Patients",
            "subheading": "",
            "para": "The need for post-treatment care is crucial for health and vitality. Here's what we recommend:",
            "items": [
                {
                    "title": "Medication Adherence",
                    "desc": "Take your assigned medications and schedules.",
                    "icon": "fa-solid fa-prescription-bottle-alt"
                },
                {
                    "title": "Healthy Lifestyle",
                    "desc": "These practices all contribute to a healthy lifestyle.",
                    "icon": "fa-solid fa-apple-alt"
                },
                {
                    "title": "Regular Check-Ups",
                    "desc": "Regular follow-up (monitoring & titration).",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Family Engagement",
                    "desc": "Use family contacts to keep people up to date and involved in care plans.",
                    "icon": "fa-solid fa-users"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about geriatric medicine",
            "items": [
                {
                    "question": "At what age should I start seeing a geriatric specialist?",
                    "answer": "We recommend consulting a geriatrician around age 65 or earlier if you have complex medical needs."
                },
                {
                    "question": "What conditions do geriatricians treat?",
                    "answer": "Geriatricians manage a wide range of conditions, including arthritis, dementia, osteoporosis, diabetes, and cardiovascular diseases."
                },
                {
                    "question": "Is geriatric medicine covered by insurance?",
                    "answer": "Many insurance plans cover geriatric care. Check with your provider for details about coverage."
                },
                {
                    "question": "How often should seniors visit a geriatrician?",
                    "answer": "Regular visits are recommended every 6-12 months, or more frequently if managing chronic conditions."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/hfhtfh.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 13,
            "title": "Geriatric Medicine in Dubai",
            "description": "Comprehensive care for elderly patients with specialized geriatric services",
            "price": 850
        }
    },
    "ar": {
        "url": "geriatric-medicine",
        "meta": {
            "title": "خدمات طب الشيخوخة في دبي | ايليت بودي هوم",
            "description": "رعاية شاملة لكبار السن في دبي. علاج متخصص للحالات المرتبطة بالعمر، والأمراض المزمنة، وتحسين جودة الحياة لكبار السن.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/geriatric-medicine",
            "og": {
                "title": "خدمات طب الشيخوخة في دبي | ايليت بودي هوم",
                "description": "رعاية متكاملة ورحيمة لكبار السن في دبي",
                "image": "https://www.elitebodyhome.com/images/geriatric-medicine-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "طب الشيخوخة"],
        "hero": {
            "title": "خدمات طب الشيخوخة في دبي",
            "subtitle": "رعاية شاملة لكبار السن",
            "description": "يُعد التقدم في العمر عملية طبيعية تتطلب احتياجات صحية أكثر تخصصًا. نُقدم في ايليت بودي هوم خدمات طب الشيخوخة عالية الجودة في دبي، والتي تهدف إلى تحسين جودة حياة كبار السن. يضم فريقنا نخبة من الأطباء المتخصصين في طب الشيخوخة يقدمون رعاية كبار السن متخصصة تتسم بالرحمة والاهتمام، لتلبية الاحتياجات الطبية والنفسية والحركية الفريدة لكبار السن، بجانب توفير خدمات الرعاية المنزلية. نُركز على الرعاية الوقائية، والتشخيص المبكر، والعلاج المتكامل لضمان حياة أكثر صحة واستقلالية لكبار السن."
        },
        "howItWorks": {
            "title": "ما هو طب الشيخوخة؟",
            "description": "طب الشيخوخة (طب كبار السن) هو فرع متخصص من الطب يُعنى باحتياجات الرعاية الصحية لكبار السن. يركز هذا التخصص على التعامل مع تعقيدات التقدم في العمر، بما في ذلك الأمراض المزمنة، والتدهور الإدراكي، ومشاكل الحركة، والصحة النفسية."
        },
        "procedureSteps": {
            "heading": "خطوات العلاج؟",
            "para": "نتبع علاجًا يركز على المريض ومخصص له، بدءًا من التقييم الشامل للحالة الصحية. إليك ما يمكن توقعه:",
            "steps": [
                {
                    "title": "التقييم الشامل",
                    "desc": "يتم مراجعة التاريخ الطبي، والأدوية، والعوامل المتعلقة بنمط الحياة، ومن ثم تُقيَم الحالة الجسدية، والعقلية، والنفسية.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "خطة رعاية فردية",
                    "desc": "وضع خطة علاجية مخصصة لمعالجة المشكلات الصحية الخاصة بك، وتُقدم بعض النصائج حول التغييرات في نمط الحياة، والعلاج، والأدوية.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "المتابعة المستمرة",
                    "desc": "ستُحدد مواعيد متابعة دورية لتتبع التقدم وتعديل العلاج عند الحاجة، بجانب التنسيق مع المتخصصين لتوفير رعاية متقدمة إذا لزم الأمر.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد خدمات طب الشيخوخة",
            "subheading": "",
            "para": "اختيار رعاية متخصصة في طب الشيخوخة يضمن حصول كبار السن على اهتمام مخصص لاحتياجاتهم الصحية الفريدة. تشمل الفوائد الرئيسية:",
            "items": [
                {
                    "title": "الإدارة الجيدة للأمراض المزمنة",
                    "desc": "رعاية متخصصة للحالات الصحية المستمرة لتحسين الاستقرار وتقليل المضاعفات.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "تعزيز الحركة وزيادة القوة البدنية",
                    "desc": "علاجات للحفاظ على الوظائف البدنية والاستقلالية.",
                    "icon": "fa-solid fa-walking"
                },
                {
                    "title": "دعم الصحة النفسية والوضوح الذهني",
                    "desc": "دعم للوظائف الإدراكية والصحة العاطفية.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "تعزيز الاستقلالية",
                    "desc": "الحفاظ على القدرة على أداء الأنشطة اليومية والعيش باستقلالية.",
                    "icon": "fa-solid fa-home"
                }
            ]
        },
        "eligibility": {
            "heading": "خدمات رعاية كبار السن لدينا",
            "subheading": "",
            "para": "تشمل خدمات رعاية كبار السن لدينا:",
            "items": [
                {
                    "title": "الوقاية من الأمراض المزمنة المرتبطة بتقدم العمر",
                    "desc": "علاجات مبتكرة للحالات المرتبطة بالعمر.",
                    "icon": "fa-solid fa-medal"
                },
                {
                    "title": "إدارة الأمراض المزمنة",
                    "desc": "رعاية متخصصة للمشكلات الصحية المستمرة.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "تحسين جودة الحياة من خلال خطط علاجية مخصصة لكل فرد",
                    "desc": "نهج مخصص لاحتياجات كل فرد.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "الرعاية الوقائية",
                    "desc": "الكشف المبكر عن المشاكل الصحية والوقاية منها.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يجب الاستعداد بشكل جيد قبل الزيارة لضمان أفضل النتائج. إليك كيفية التحضير لموعدك:",
            "items": [
                {
                    "title": "التاريخ الطبي",
                    "desc": "يلزم إحضار سجل مفصل للحالات الصحية السابقة، والعلاج والأدوية المستخدمة.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "قائمة بالمخاوف",
                    "desc": "تدوين جميع الأعراض أو الأسئلة أو المشاكل التي ترغب في مناقشتها مع الطبيب.",
                    "icon": "fa-solid fa-list"
                },
                {
                    "title": "الأدوية والمكملات الغذائية",
                    "desc": "تقديم قائمة بجميع الأدوية والمكملات الغذائية المستخدمة حاليًا، بما في ذلك الجرعات.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "دعم العائلة",
                    "desc": "اصطحاب أحد أفراد الأسرة أو مقدم رعاية موثوق لمساعدتك أثناء الموعد.",
                    "icon": "fa-solid fa-hands-helping"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يوفر علاجنا المتكامل النتائج التالية:",
            "items": [
                {
                    "title": "تحسن الصحة العامة",
                    "desc": "إدارة فعالة للأمراض المزمنة والأمراض المرتبطة بالتقدم في العمر.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "تعزيز الصحة العقلية والنفسية",
                    "desc": "تحسن المزاج، والذاكرة، والصحة النفسية بشكل عام.",
                    "icon": "fa-solid fa-smile"
                },
                {
                    "title": "زيادة الاستقلالية",
                    "desc": "تقليل الاعتماد على مقدمي الرعاية بفضل تعزيز الحركة والقوة البدنية.",
                    "icon": "fa-solid fa-wheelchair"
                },
                {
                    "title": "تطور جودة الحياة",
                    "desc": "تعزيز الرفاهية الجسدية والنفسية والاجتماعية بشكل عام.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "تُعد الرعاية بعد العلاج ضرورية للحفاظ على الصحة والاستقلالية. إليك بعض النصائح الهامة:",
            "items": [
                {
                    "title": "الالتزام بالأدوية",
                    "desc": "يجب تناول الأدوية الموصوفة وفقاً للجرعات والجداول الزمنية المحددة.",
                    "icon": "fa-solid fa-prescription-bottle-alt"
                },
                {
                    "title": "اتباع نمط حياة صحي",
                    "desc": "يجب اتباع نظام غذائي متوازن بجانب ممارسة الأنشطة البدنية بانتظام.",
                    "icon": "fa-solid fa-apple-alt"
                },
                {
                    "title": "الفحوصات الدورية",
                    "desc": "يلزم حضور المواعيد الطبية لمتابعة الحالة الصحية وإجراء التعديلات اللازمة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "إشراك العائلة",
                    "desc": "يجب إبقاء أفراد العائلة على اطلاع ومشاركتهم في خطط الرعاية.",
                    "icon": "fa-solid fa-users"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "أسئلة شائعة حول طب الشيخوخة",
            "items": [
                {
                    "question": "متى يجب أن أبدأ بزيارة طبيب أمراض الشيخوخة؟",
                    "answer": "يُنصح بمراجعة طبيب أمراض الشيخوخة بدءًا من سن 65 عامًا أو قبل ذلك في حال وجود احتياجات طبية معقدة."
                },
                {
                    "question": "ما الحالات التي يعالجها طبيب أمراض الشيخوخة؟",
                    "answer": "يعالج أطباء الشيخوخة مجموعة واسعة من الأمراض، بما في ذلك التهاب المفاصل، والخرف، وهشاشة العظام، والسكري، وأمراض القلب."
                },
                {
                    "question": "هل يضم التأمين تكاليف طب الشيخوخة؟",
                    "answer": "تتضمن العديد من خطط التأمين الرعاية الطبية لكبار السن. يُفضل مراجعة التأمين الخاص بك لمعرفة تفاصيل."
                },
                {
                    "question": "كم مرة يُنصح كبار السن بزيارة طبيب أمراض الشيخوخة؟",
                    "answer": "يُوصى بزيارات دورية كل 6 إلى 12 شهرًا، أو بشكل أكثر تكرارًا في حال التعامل مع أمراض مزمنة."
                }
            ]
        }
    }
}